import { useAppDispatch } from "../../hook";
import { sendEventThunk } from "../conversationSlice";
import { GROWTHBOOK_EXPERIMENT_VIEWED_EVENT_NAME } from "./types";
export function buildExperimentViewedParams({ experimentId, variationId, userId, guestUserId }) {
    const experimentEventDetails = {
        experiment_id: experimentId,
        variation_id: variationId,
    };
    if (userId)
        experimentEventDetails["user_id"] = userId;
    if (guestUserId)
        experimentEventDetails["guest_user_id"] = `gid_${guestUserId}`;
    return { event_name: GROWTHBOOK_EXPERIMENT_VIEWED_EVENT_NAME, ["data"]: experimentEventDetails };
}
export default function useEvent() {
    const dispatch = useAppDispatch();
    const sendEventOnAdView = async (data) => {
        const payload = {
            event_name: "ads_megabrain_view",
            ...data,
        };
        return dispatch(sendEventThunk(payload)).unwrap();
    };
    const sendEventOnAdClick = (data) => {
        const payload = {
            event_name: "ads_megabrain_click",
            ...data,
        };
        return dispatch(sendEventThunk(payload)).unwrap();
    };
    const sendEvent = ({ event_name, data }) => {
        const payload = {
            event_name,
            ...data,
        };
        return dispatch(sendEventThunk(payload)).unwrap();
    };
    return {
        sendEventOnAdView,
        sendEventOnAdClick,
        sendEvent,
    };
}
